import styled, { keyframes } from 'styled-components';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import PlayCircleBig from '@icon/PlayCircleBig';
import { Spacings, BgColors } from '../../../../styleConstants';

const PlayIcon = styled(PlayCircleBig)`
  border-radius: 50%;
`;

const ShadowPulse = keyframes`
  0% { box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    color: 'rgba(235,87,87, 0.4)'
  })}; }
  70% { box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    spread: '10px',
    color: 'rgba(235,87,87, 0)'
  })}; }
  100% {
    box-shadow: none;
  }
`;

const LiveIcon = styled(PlayIcon)`
  box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    color: 'rgba(235,87,87, 0.4)'
  })};
  animation: ${ShadowPulse} 2s infinite;
  :hover {
    animation: none;
  }
`;

export const Live = <LiveIcon size="40px" color={BgColors.LIVE} />;
export const Play = <PlayIcon size="40px" color="#2D81F7" />;
